import { jsx } from "react/jsx-runtime";
import { memo, useRef, useLayoutEffect } from "react";
import { useSectionTabsRegistration } from "../SectionTabs/Context.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { Stack } from "../Stack/Stack.js";
const metaTab = {
  id: "meta-section-aside",
  label: "Meta",
  isMeta: true
};
const LayoutPageAside = memo(({ children }) => {
  const componentClassName = `${useClassNamePrefix()}layout-page-aside`;
  const [registerTab, unregisterTab] = useSectionTabsRegistration();
  const element = useRef(null);
  useLayoutEffect(() => {
    const mediaQueryList = matchMedia("(min-width: 1280px)");
    const tabRegistration = () => {
      if (element.current) {
        if (!mediaQueryList.matches) {
          registerTab(metaTab);
        } else {
          unregisterTab(metaTab);
        }
      } else {
        console.error("Missing element");
      }
    };
    tabRegistration();
    mediaQueryList.addEventListener("change", tabRegistration);
    return () => {
      unregisterTab(metaTab);
      mediaQueryList.removeEventListener("change", tabRegistration);
    };
  });
  return /* @__PURE__ */ jsx("div", { ref: element, id: metaTab.id, className: componentClassName, children: /* @__PURE__ */ jsx(Stack, { gap: "large", direction: "vertical", className: `${componentClassName}-content`, children }) });
});
LayoutPageAside.displayName = "LayoutPageAside";
export {
  LayoutPageAside
};
//# sourceMappingURL=LayoutPageAside.js.map
